import {useToast} from '@/composables/useToast';
import {PartnerStore, usePartnerStore} from "@/stores/partner-store";
import {storeToRefs} from "pinia";

export const usePartner = () => {

  const partnerStore: PartnerStore = usePartnerStore();
  const {
    partnerSlug,
    partnerData,
    partnerContent,
    loading
  } = storeToRefs(partnerStore);

  const {showToast} = useToast();

  const handleGetPartnerInfoBySlug = async (
    slug: string,
  ) => {
    try {
      await partnerStore.getPartnerInfoBySlug(slug);
    } catch (error) {
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    }
  };
  const handleGetPartnerWebContent = async (
    url: string,
  ) => {
    try {
      await partnerStore.getUrlContent(url);
    } catch (error) {
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    }
  };
  return {handleGetPartnerInfoBySlug, handleGetPartnerWebContent, partnerSlug, partnerData, partnerContent, loading};
};
